import { render, staticRenderFns } from "./CandidatesSetMijn.vue?vue&type=template&id=772309ea&lang=pug"
import script from "./CandidatesSetMijn.vue?vue&type=script&lang=js"
export * from "./CandidatesSetMijn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports